export enum WorkflowStatus {
  "MISSING" = "missing",
  "DRAFT" = "draft",
  "PUBLISHED" = "published",
}
